/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TGetBlogListModel,
  IGetBlogListRequest,
  IMappers,
  IGetBlogListResponse,
  IGetBlogListResponseError,
  TGetBlogListResponse,
} from './types';

const defaultConfig: TGetBlogListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v2/get-blog-list/',
  hostType: 'api',
} as TGetBlogListModel;

function createGetBlogListModel(parameters: IGetBlogListRequest): TGetBlogListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetBlogListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetBlogListRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetBlogList<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetBlogListOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetBlogListResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetBlogListModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBlogListResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetBlogListResponseError);
    }
  }

  return { response, statusCode } as TGetBlogListResponse;
}

export { defaultConfig, createGetBlogListModel, fetchGetBlogList };
